import approvalDetail from "./approvalDetail";
import flowDetail from "./flowDetail";
import {readMark} from "../../../../services/checkModule";

export default {
  components: { approvalDetail, flowDetail },
  methods: {
    //审核
    see(row,tag=false,markread) {
      switch (row.typeId) {
        case 5:
          this.viewType = 'approvalDetail';
          break;
        case 6:
          this.viewType = 'flowDetail';
          break;
        case 7:
          this.viewType = 'contractDetail';
          break;
        case 8:
          this.viewType = 'positiveDetail';
          break;
        case 9:
          this.viewType = 'dynamicFormDetail';
          break;
        default:
          this.viewType = 'see';
          break;
      }
      tag?this.taskId = row.taskId:'';
      this.currentId = row.id;
      if(markread){ // 标记已读
        let param = {ccId:row.ccId};
        readMark(param).then(res=>{
        })
      }
    },
    edit(row,tag=false){
      switch (row.typeId) {
        case 1:
        case 2:
        case 3:
        case 4:
          this.viewType = 'decorationEdit';
          this.selectData = row;
          break;
        case 5:
          this.viewType = 'approvalEdit';
          break;
        case 6:
          this.viewType = 'entryFlowEdit';
          break;
        case 7:
          this.viewType = 'contractEdit';
          break;
        case 8:
          this.viewType = 'positiveEdit';
          break;
        case 9:
          this.viewType = 'dynamicFormEdit';
          break;
        default:
          this.viewType = 'see';
          break;
      }
      this.currentId = row.id;
    },
    close() {
      this.viewType = 'list';
      this.$nextTick(() => {
        this.getData()
      })
    },
  },
}